import { takeEvery, takeLeading } from 'redux-saga/effects';

import { resourceSagaUtils, resourceStoreTypes } from 'app-components/flux/core';

import { transformResponseToVehicles, transformVehicleToRequestData } from 'data/vehicles/transformers';

import * as actions from './actions';
import { getLastSyncDate } from './selectors';

// ===============================================================================================
// SAGAS functions for vehicles.  These are the functions responsible for communicating directly
// with external endpoints asynchronously.

// ====================================================
// ACTION WATCHERS to trigger SAGAS calls

const mkResourceConfig = (successAction, failureAction) =>
  resourceStoreTypes.mkQcsSyncResourceConfig({
    resourceName: 'vehicle',
    resourceBaseUrl: '/miles/vehicles',
    getLastSyncDate,

    transformResponseToResources: transformResponseToVehicles,
    transformResourceToRequestData: transformVehicleToRequestData,

    successAction,
    failureAction,
  });

export function* getVehiclesActionWatcher() {
  const config = mkResourceConfig(actions.getVehiclesSuccess, actions.getVehiclesFailure);
  yield takeLeading(actions.getVehicles, resourceSagaUtils.qcsSyncGetResources, config);
}

export function* createVehicleActionWatcher() {
  const config = mkResourceConfig(actions.createVehicleSuccess, actions.createVehicleFailure);
  yield takeEvery(actions.createVehicle, resourceSagaUtils.qcsSyncCreateResource, config);
}

export function* updateVehicleActionWatcher() {
  const config = mkResourceConfig(actions.updateVehicleSuccess, actions.updateVehicleFailure);
  yield takeEvery(actions.updateVehicle, resourceSagaUtils.qcsSyncUpdateResource, config);
}

export function* deleteVehicleActionWatcher() {
  const config = mkResourceConfig(actions.deleteVehicleSuccess, actions.deleteVehicleFailure);
  yield takeEvery(actions.deleteVehicle, resourceSagaUtils.qcsSyncDeleteResource, config);
}

// ====================================================
// EXPORTS

export default [
  getVehiclesActionWatcher,
  createVehicleActionWatcher,
  updateVehicleActionWatcher,
  deleteVehicleActionWatcher,
];
